import * as colors from 'assets/theme/colors';

const transition =
    'box-shadow 0.2s cubic-bezier(0.4, 0, 1, 1), background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)';

export const button = {
    MuiButton: {
        root: {
            color: colors.neutrals.A10,
        },
        text: {
            fontSize: 16,
        },
        containedPrimary: {
            color: colors.neutrals.A10,
            padding: '12px 24px',
            borderRadius: 4,
            fontSize: 16,
            '&:active': {
                backgroundColor: colors.primary.A40,
            },
            '&:hover': {
                backgroundColor: colors.accent.A01,
                boxShadow: '0px 4px 8px rgba(104, 107, 128, 0.3)',
            },
            '&:focus': {
                outline: `solid 1px ${colors.primary.A00}`,
                border: `solid 1px ${colors.neutrals.A10}`,
                backgroundColor: colors.primary.A00,
                borderCollapse: 'separate',
                padding: '11px 23px',
                transition: transition,
            },
            '&:disabled': {
                backgroundColor: colors.neutrals.A30,
            },
        },
        containedSecondary: {
            color: colors.neutrals.A10,
            padding: '12px 24px',
            borderRadius: '4px',
            fontSize: 16,
            '&:active': {
                backgroundColor: colors.primary.A40,
            },
            '&:hover': {
                backgroundColor: colors.neutrals.A60,
                boxShadow: '0px 4px 8px rgba(104, 107, 128, 0.3)',
            },
            '&:focus': {
                outline: `solid 1px ${colors.secondary.A01}`,
                border: `solid 1px ${colors.neutrals.A10}`,
                borderCollapse: 'separate',
                padding: '11px 23px',
                backgroundColor: colors.secondary.A01,
                transition: transition,
            },
            '&:disabled': {
                color: colors.neutrals.A40,
                outlineColor: colors.neutrals.A30,
            },
        },
        outlined: {
            padding: '11px 23px',
            borderRadius: '4px',
            borderWidth: '1px',
            color: colors.neutrals.A60,
            backgroundColor: colors.neutrals.A10,
            outline: `solid 1px ${colors.neutrals.A60}`,
            '&:hover': {
                color: colors.neutrals.A50,
                outline: `solid 2px ${colors.neutrals.A50}`,
            },
            '&:active': {
                color: colors.secondary.A02,
                outline: `solid 2px ${colors.secondary.A02}`,
            },
            '&:focus': {
                color: colors.secondary.A01,
                outline: `solid 2px ${colors.secondary.A01}`,
                border: `solid 1px ${colors.secondary.A01}`,
                borderCollapse: 'separate',
            },
            '&:disabled': {
                color: colors.neutrals.A30,
                outline: `solid 2px ${colors.neutrals.A30}`,
            },
        },
    },
};
